import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">
            分类浏览
          </span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading text-foreground-950">
            探索你喜欢的 <span className="text-primary-500 italic">韩漫类型</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">六大分类，覆盖热门韩漫类型，总有一款适合你</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden aspect-[3/4] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={`${cat.name}漫画`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-base font-semibold text-background-50">{cat.name}</h3>
                <p className="text-xs text-background-100/80 mt-1">{cat.description}</p>
                <p className="text-xs text-background-100/60 mt-2">{cat.count}部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}